export * from './MoneyTypeCoinsIcon';
export * from './MoneyTypeCoinsIcon16Light';
export * from './MoneyTypeCoinsIcon16Regular';
export * from './MoneyTypeCoinsIcon16Solid';
export * from './MoneyTypeCoinsIcon20Light';
export * from './MoneyTypeCoinsIcon20Regular';
export * from './MoneyTypeCoinsIcon20Solid';
export * from './MoneyTypeCoinsIcon24Regular';
export * from './MoneyTypeCoinsIcon24Solid';
export * from './MoneyTypeCoinsIcon32Regular';
export * from './MoneyTypeCoinsIcon64Regular';
